import { render, staticRenderFns } from "./HeadDetail.vue?vue&type=template&id=50276648"
import script from "./HeadDetail.vue?vue&type=script&lang=js"
export * from "./HeadDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports